import {
  type WorkoutFormat,
  type WorkoutItemGroupType,
} from "api-client/legacy-trpc";

import { type TranslationKey } from "src/types";

import { type WorkoutItemData } from "./WorkoutEditStore";

export interface InsertRootExerciseButtonProps {
  parentId: string;
}

export interface InsertWorkoutItemProps {
  index: number;
  parentId: string | null;
  previousItemId?: string;
  itemId?: string;
}

export type ParentContext = {
  format: WorkoutFormat | null;
  groupType: WorkoutItemGroupType | null;
};

type SectionFormatOption = {
  format: WorkoutFormat;
  labelKey: TranslationKey;
};

export function getParentContext(
  parent: WorkoutItemData | undefined,
): ParentContext | null {
  if (parent?.type === "GROUP") {
    return {
      format: parent.format,
      groupType: parent.groupType,
    };
  }

  return null;
}

export function getAllowedSectionOptions(parentContext: ParentContext | null): {
  sections: SectionFormatOption[];
} {
  const allSections: SectionFormatOption[] = [
    { format: "REGULAR", labelKey: "editWorkout.sectionFormat.regular" },
    { format: "AMRAP", labelKey: "editWorkout.sectionFormat.amrap" },
    { format: "TIMED", labelKey: "editWorkout.sectionFormat.timed" },
    { format: "FREESTYLE", labelKey: "editWorkout.sectionFormat.freestyle" },
  ];

  if (parentContext === null) {
    return { sections: allSections };
  }

  if (parentContext.groupType === "SUPER_SET") {
    return { sections: [] };
  }

  if (parentContext.format === "AMRAP" || parentContext.format === "TIMED") {
    return { sections: [] };
  }

  return { sections: [] };
}
